import { Link } from 'react-router-dom'

/** Dash-style brand mark: blue tile + title + version subtitle. */
export function BrandMark({
  siteTitle,
  logoText = 'BK',
  appVersion,
  to = '/',
  compact = false,
  tone = 'dark',
}) {
  const initials = (logoText || 'BK').slice(0, 4).toUpperCase()
  const versionLabel = appVersion ? `v${String(appVersion).replace(/^v/i, '')}` : null
  const titleClass = tone === 'light' ? 'text-brand' : 'text-white'
  const versionClass =
    tone === 'light' ? 'text-brand-muted' : 'text-sidebar-foreground/50'

  return (
    <Link to={to} className="flex min-w-0 items-center gap-2.5 no-underline">
      <span
        className={[
          'flex shrink-0 items-center justify-center rounded-lg bg-[#0B5FFF] font-bold leading-none text-white',
          compact ? 'h-8 w-8 text-xs' : 'h-9 w-9 text-sm',
        ].join(' ')}
        aria-hidden
      >
        {initials}
      </span>
      <span className="min-w-0">
        <span
          className={[
            'block truncate font-display tracking-tight',
            titleClass,
            compact ? 'text-base' : 'text-lg',
          ].join(' ')}
        >
          {siteTitle}
        </span>
        {versionLabel ? (
          <span
            className={[
              'mt-0.5 block truncate text-[11px] leading-none',
              versionClass,
            ].join(' ')}
          >
            {versionLabel}
          </span>
        ) : null}
      </span>
    </Link>
  )
}
